<template>
  <div class="modal-content">
    <div class="body overflow-auto">
      <div class="flex my-10 mx-10 justify-center items-center">
        <div class="flex  mr-6">
          <svg
            width="102"
            height="118"
            viewBox="0 0 102 118"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="53" cy="61.4272" r="49" fill="#E0E0E0" />
            <g filter="url(#filter0_ddd)">
              <path
                d="M25.5364 94.6214L81.4075 84.4544C83.4292 84.0865 84.7698 82.1495 84.4019 80.1278L71.823 11.0026C71.4551 8.9809 69.5181 7.64031 67.4964 8.0082L11.6253 18.1752C9.60365 18.5431 8.26306 20.4801 8.63095 22.5018L21.2098 91.627C21.5777 93.6487 23.5149 94.9893 25.5364 94.6214Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter1_ddd)">
              <path
                d="M25.0079 94.9586L81.5951 90.1797C83.6427 90.0068 85.1623 88.2068 84.9894 86.1592L79.0768 16.148C78.9038 14.1004 77.1038 12.5808 75.0562 12.7537L18.4691 17.5326C16.4215 17.7055 14.9019 19.5055 15.0748 21.5531L20.9874 91.5643C21.1604 93.6119 22.9605 95.1315 25.0079 94.9586Z"
                fill="white"
              />
            </g>
            <g clip-path="url(#clip0)">
              <path
                d="M79.3291 23.2112C78.8447 23.0707 78.5661 22.5643 78.7065 22.08L79.5871 19.0439C80.4228 16.1627 78.7585 13.1389 75.8775 12.3033C72.9963 11.4677 69.9725 13.1319 69.1369 16.013C68.9964 16.4974 68.4901 16.776 68.0057 16.6355C67.5213 16.495 67.2426 15.9887 67.3831 15.5043C68.4991 11.656 72.5378 9.43336 76.386 10.5495C80.2343 11.6656 82.4569 15.7043 81.3408 19.5525L80.4602 22.5886C80.3199 23.073 79.8134 23.3517 79.3291 23.2112Z"
                fill="#FF5252"
              />
              <g filter="url(#filter2_ddd)">
                <path
                  d="M24.6054 98.3295H81.3939C83.4488 98.3295 85.1145 96.6638 85.1145 94.6089V24.3485C85.1145 22.2936 83.4488 20.6279 81.3939 20.6279H24.6054C22.5505 20.6279 20.8848 22.2936 20.8848 24.3485V94.6089C20.8848 96.6638 22.5507 98.3295 24.6054 98.3295Z"
                  fill="white"
                />
              </g>
              <path
                d="M67.4595 36.322C64.3498 35.42 62.5536 32.1562 63.4555 29.0466L67.3836 15.503C67.5241 15.0186 68.0304 14.7399 68.5149 14.8804C68.9993 15.0209 69.2779 15.5273 69.1374 16.0117L65.2094 29.5551C64.5879 31.6978 65.8255 33.9466 67.9682 34.568C70.1108 35.1894 72.3595 33.9518 72.981 31.8092L76.9091 18.2657C77.3163 16.8615 76.5053 15.3878 75.1011 14.9806C73.6969 14.5733 72.2232 15.3844 71.816 16.7885L69.3909 25.15C69.2504 25.6344 68.7439 25.9131 68.2596 25.7726C67.7752 25.6321 67.4965 25.1258 67.637 24.6414L70.0622 16.2799C70.7499 13.9087 73.2386 12.539 75.6098 13.2268C77.9809 13.9145 79.3506 16.4032 78.6629 18.7744L74.7348 32.3178C73.8329 35.4276 70.5693 37.2239 67.4595 36.322Z"
                fill="#FF5252"
              />
              <path
                d="M72.1625 71.7159H33.7693C33.0239 71.7159 32.4199 71.1119 32.4199 70.3665C32.4199 69.6211 33.0239 69.0171 33.7693 69.0171H72.1625C72.9077 69.0171 73.5119 69.6211 73.5119 70.3665C73.5119 71.1117 72.9077 71.7159 72.1625 71.7159Z"
                fill="#FF5252"
              />
              <path
                d="M58.5521 80.5777H33.7693C33.0239 80.5777 32.4199 79.9736 32.4199 79.2283C32.4199 78.4829 33.0239 77.8789 33.7693 77.8789H58.5521C59.2974 77.8789 59.9016 78.4829 59.9016 79.2283C59.9016 79.9736 59.2974 80.5777 58.5521 80.5777Z"
                fill="#404B58"
              />
              <path
                d="M64.3996 89.4415H33.7693C33.0239 89.4415 32.4199 88.8375 32.4199 88.0921C32.4199 87.3467 33.0239 86.7427 33.7693 86.7427H64.3996C65.1448 86.7427 65.749 87.3467 65.749 88.0921C65.749 88.8373 65.1448 89.4415 64.3996 89.4415Z"
                fill="#404B58"
              />
              <path
                d="M39.3953 53.2187C38.6499 53.2187 38.0459 52.6147 38.0459 51.8693V49.2205C38.0459 48.4751 38.6499 47.8711 39.3953 47.8711C40.1407 47.8711 40.7447 48.4751 40.7447 49.2205V51.8693C40.7447 52.6146 40.1409 53.2187 39.3953 53.2187Z"
                fill="#404B58"
              />
              <path
                d="M71.0096 53.2187C70.2642 53.2187 69.6602 52.6147 69.6602 51.8693V49.2205C69.6602 48.4751 70.2642 47.8711 71.0096 47.8711C71.755 47.8711 72.359 48.4751 72.359 49.2205V51.8693C72.359 52.6146 71.7548 53.2187 71.0096 53.2187Z"
                fill="#404B58"
              />
              <ellipse
                cx="55.2587"
                cy="54.0703"
                rx="4.24799"
                ry="4.24798"
                fill="#404B58"
              />
            </g>
            <circle cx="85.5613" cy="101.931" r="15.8591" fill="#FF5252" />
            <path
              d="M80.4639 107.029L90.1184 96.8335"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M80.1935 97.104L90.3887 106.759"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <defs>
              <filter
                id="filter0_ddd"
                x="0.570312"
                y="0.947266"
                width="91.8924"
                height="102.735"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="1.5" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow"
                  result="effect2_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow"
                  result="effect3_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect3_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_ddd"
                x="7.06152"
                y="5.74023"
                width="85.9414"
                height="98.2317"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="1.5" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow"
                  result="effect2_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow"
                  result="effect3_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect3_dropShadow"
                  result="shape"
                />
              </filter>
              <filter
                id="filter2_ddd"
                x="-1.11523"
                y="3.62793"
                width="108.23"
                height="123.702"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="7" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="5" />
                <feGaussianBlur stdDeviation="11" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow"
                  result="effect2_dropShadow"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="12" />
                <feGaussianBlur stdDeviation="8.5" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect2_dropShadow"
                  result="effect3_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect3_dropShadow"
                  result="shape"
                />
              </filter>
              <clipPath id="clip0">
                <rect
                  width="92.12"
                  height="108.182"
                  fill="white"
                  transform="translate(7.50586 6.20947)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="warning-text text-2xl w-3/4 ml-4">
          <p
            v-html="
            $sanitize($t('message.uploadImageComponent.modals.handledErrorsMessage', {
                quantity: listOfErrors.length,
              }))
            "
          />
        </div>
      </div>
      <div
        class="errors-container mx-10 mb-10 rounded border-l border-r border-t border-solid border-gray-400"
      >
        <div
          v-for="(error, index) in listOfErrors"
          :key="index"
          class="p-3 border-b border-solid border-gray-400"
        >
          <p class="text-base">{{ error.nombre_tipo_documento }}</p>
          <p class="text-sm capitalize">
            {{ error.nombre_usuario }} {{ error.apellido }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="zt-modal-footer flex justify-center lg:justify-end items-center p-4"
    >
      <zt-button
        data-vs-button="approve-error-retry"
        class="ml-1 button-retry"
        outlined
        :loader="loading"
        :loaderTxt="
          $t('message.uploadImageComponent.modals.buttonRetryLoading')
        "
        @click="typeOfRetry === 'approve' ? $emit('approveLoad') : $emit('denyLoad')"
        >{{ $t("message.uploadImageComponent.modals.buttonRetry") }}</zt-button
      >
      <zt-button
        data-vs-button="approve-error-isok"
        class="ml-1"
        @click="$emit('closeModalAndUpdateTask')"
        >{{
          $t("message.uploadImageComponent.modals.buttonUnderstand")
        }}</zt-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["listOfErrors", "typeOfRetry", "loading"],
};
</script>
<style lang="scss" scoped>
.body {
  max-height: 30rem;
}
.button-retry {
  background-color: transparent;
  color: #4f41a3 !important;
}
</style>
